import { createRouter, createWebHashHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import NotFound from "@/views/NotFound";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
    redirect: "/main",
    children: [
      {
        path: "/main",
        name: "main",
        component: () => import("../views/MainPage.vue"),
        meta: { pageName: "首页" },
      },
      {
        path: "/product",
        name: "product",
        meta: { pageName: "产品中心" },
        children: [
          {
            path: "",
            name: "ProductDefault",
            component: () => import("../views/ProductDetailPage.vue"),
          },
          {
            path: ":id",
            name: "ProductDetail",
            component: () => import("../views/ProductDetailPage.vue"),
            meta: { pageName: "产品详情" },
          },
        ],
      },
      {
        path: "/news",
        name: "news",
        component: () => import("../views/NewsPage.vue"),
        meta: { pageName: "新闻资讯" },
        children: [
          {
            path: "/news/:id",
            name: "NewsDetailPage",
            component: () => import("../views/NewsDetailPage.vue"),
          },
          {
            path: "",
            component: () => import("../views/NewsItemsPage"),
          },
        ],
      },
    ],
  },

  // ============ 管理后台路由 ============
  {
    path: "/admin/login",
    name: "AdminLogin",
    component: () => import("../admin/AdminLogin.vue"),
    meta: { title: "管理后台登录" },
  },
  {
    path: "/admin",
    name: "AdminLayout",
    component: () => import("../admin/AdminLayout.vue"),
    redirect: "/admin/dashboard",
    meta: { requiresAuth: true },
    children: [
      {
        path: "dashboard",
        name: "AdminDashboard",
        component: () => import("../admin/DashboardPage.vue"),
        meta: { title: "仪表盘" },
      },
      {
        path: "menus",
        name: "AdminMenus",
        component: () => import("../admin/MenuManage.vue"),
        meta: { title: "菜单管理" },
      },
      {
        path: "contents",
        name: "AdminContents",
        component: () => import("../admin/ContentManage.vue"),
        meta: { title: "内容管理" },
      },
      {
        path: "products",
        name: "AdminProducts",
        component: () => import("../admin/ProductManage.vue"),
        meta: { title: "产品管理" },
      },
      {
        path: "news",
        name: "AdminNews",
        component: () => import("../admin/NewsManage.vue"),
        meta: { title: "新闻管理" },
      },
      {
        path: "messages",
        name: "AdminMessages",
        component: () => import("../admin/MessageManage.vue"),
        meta: { title: "留言管理" },
      },
    ],
  },

  { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFound },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 管理后台路由守卫
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const token = localStorage.getItem("admin_token");
    if (!token) {
      next({ path: "/admin/login" });
    } else {
      next();
    }
  } else {
    next();
  }
});

const defaultTitle = "洞见信息 | 工业互联网与化工安全";

router.afterEach((to) => {
  window.scrollTo(0, 0);
  if (to.meta && to.meta.pageName) {
    document.title = `${to.meta.pageName} - ${defaultTitle}`;
  } else if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} - 洞见后台管理`;
  } else {
    document.title = defaultTitle;
  }
});

export default router;
